import { useIntl } from 'react-intl';
import { MenuItemRestaurantLinkKind } from '~/libs/gql/types';

// Button text for a dish's link out to the restaurant, worded for where the link goes
export const useRestaurantLinkText = () => {
  const intl = useIntl();

  return (kind: MenuItemRestaurantLinkKind, restaurantName: string) => {
    switch (kind) {
      case MenuItemRestaurantLinkKind.Order:
        return intl.formatMessage({ defaultMessage: 'Order' });
      case MenuItemRestaurantLinkKind.OrderRestaurant:
        return intl.formatMessage({ defaultMessage: 'Order from {restaurantName}' }, { restaurantName });
      case MenuItemRestaurantLinkKind.Website:
        return intl.formatMessage({ defaultMessage: 'Visit website' });
      default:
        throw new Error(`Unknown restaurant link kind: ${String(kind)}`);
    }
  };
};
